<!-- My Library: poster-style playlist cards; network colours through --vd-* variables -->
<div class="lib-page" [ngStyle]="themeVars">
  <button type="button" class="lib-back" (click)="goBack()"><app-vd-icon name="back"></app-vd-icon> Back</button>

  <header class="lib-head">
    <div>
      <h1 class="lib-title">My Library</h1>
      <p class="lib-sub">Your saved videos and playlists</p>
    </div>
    <span class="lib-total" *ngIf="playListAry.length">{{ playListAry.length }} {{ playListAry.length == 1 ? 'playlist' : 'playlists' }}</span>
  </header>

  <div class="lib-grid" *ngIf="playListAry.length">
    <article class="lib-card" *ngFor="let playList of playListAry">
      <button type="button" class="lib-cover" (click)="goToPlaylist(playList.id)" [attr.aria-label]="'Open ' + playList.playlist_name">
        <ng-container *ngIf="cover(playList) as images">
          <span class="lib-mosaic" *ngIf="images.length == 4">
            <img *ngFor="let src of images" [src]="src" alt="" loading="lazy">
          </span>
          <img class="lib-img" *ngIf="images.length == 1" [src]="images[0]" alt="" loading="lazy">
          <span class="lib-art" *ngIf="!images.length" aria-hidden="true">{{ initial(playList.playlist_name) }}</span>
        </ng-container>
        <span class="lib-shade" aria-hidden="true"></span>
        <span class="lib-chip" *ngIf="countLabel(playList) as count">
          <app-vd-icon [name]="playList.playlist_type == 'audio' ? 'polls' : 'play'"></app-vd-icon>{{ count }}
        </span>
        <span class="lib-play" aria-hidden="true"><app-vd-icon name="play"></app-vd-icon></span>
        <span class="lib-caption">
          <span class="lib-name">{{ playList.playlist_name }}</span>
          <span class="lib-kind">{{ playList.playlist_type == 'audio' ? 'Audio playlist' : 'Video playlist' }}</span>
        </span>
      </button>
      <div class="lib-actions">
        <button type="button" class="lib-glass" aria-label="Edit playlist" matTooltip="Edit" matTooltipPosition="above"
          (click)="rightSideNav(playList, 'Edit')"><app-vd-icon name="edit"></app-vd-icon></button>
        <button type="button" class="lib-glass is-danger" aria-label="Delete playlist" matTooltip="Delete" matTooltipPosition="above"
          (click)="deletePlaylist(playList)"><app-vd-icon name="delete"></app-vd-icon></button>
      </div>
    </article>
  </div>

  <div class="lib-empty" *ngIf="loaded && !playListAry.length">
    <span class="lib-empty-icon"><app-vd-icon name="playlist"></app-vd-icon></span>
    <p class="lib-empty-title">No playlists yet</p>
    <p class="lib-empty-text">Tap "Add to playlist" on any video to save it here.</p>
  </div>

  <div class="lib-backdrop" *ngIf="openRightSideNav" (click)="openRightSideNav = false"></div>
  <aside class="rightsidenav lib-panel" *ngIf="openRightSideNav" role="dialog" [attr.aria-label]="formType + ' playlist'">
    <div class="lib-panel-head">
      <div class="formHeading">{{ formType }} playlist</div>
      <button type="button" class="lib-close" aria-label="Close" (click)="openRightSideNav = false">&times;</button>
    </div>
    <app-add-playlist [playlistPatchData]="editData" [organizationId]="organization_id" (newItemEvent)="getResultFromAddList($event)"></app-add-playlist>
  </aside>
</div>
